import { useEffect } from 'react';

type FormReadyWindow = Window & { __mobilityFormReady?: boolean };

export const useFormReadyFlag = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const win = window as FormReadyWindow;
    win.__mobilityFormReady = true;
    return () => {
      delete win.__mobilityFormReady;
    };
  }, []);
};
